import React from 'react';
import './styles.css';

/*
 * size and iconOnly are the sheets' five sizes. They are opt-in: leave them off
 * and the button keeps the height its caller asks for, which is how every
 * button in the app is written today. Passing height alongside size still wins,
 * so a caller can take a standard size and stretch it.
 */
const SilverButton = React.forwardRef(({
                                           disabled,
                                           loading = false,
                                           children,
                                           onClick,
                                           width = '100%',
                                           height = null,
                                           size = null,
                                           iconOnly = false,
                                           type = 'submit',
                                           variant = 'default',
                                           expandedHover = false,
                                           styles = {},
                                           className = '',
                                           asDiv,
                                           onMouseDown = () => {}
                                       }, ref) => {

    const Component = asDiv ? 'div' : 'button';

    let classes = className + ' ds-button silver-button';

    if (size) {
        classes += ' ds-button--' + size;
    }

    if (iconOnly) {
        classes += ' ds-button--icon';
    }

    if (variant === 'ghost') {
        classes += ' silver-button-ghost';
        if (expandedHover) {
            classes += ' silver-button-ghost--expanded-hover';
        }
    }

    if (variant === 'outline') {
        classes += ' silver-button-outline';
    }

    return (
        <Component
            ref={ref}
            disabled={disabled || loading}
            type={type}
            className={classes}
            style={{
                width: width,
                height: height || (size ? undefined : '50px'),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '5px',
                ...styles
            }}
            onClick={onClick}
            onMouseDown={onMouseDown}
        >
            {loading && <span className="ds-button__spinner"/>}
            {children}
        </Component>
    );
});

export default SilverButton;



// WEBPACK FOOTER //
// ./src/components-new/buttons/SilverButton/index.jsx